<template>
    <div class="wrapper bg-slate-200 h-[450px] p-8 md:p-20">
        <div class="text-white relative top-1/2 space-y-2">
            <div class="font-bold text-4xl md:text-6xl head">Give to the work</div>
            <div class="text-xl font-bold uppercase">walking with god daily</div>
        </div>
    </div>
</template>

<script setup>
defineProps([ 'title' ])
</script>

<style scoped>
.wrapper{
    background-image: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.5)), url('../../assets/images/give.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}
</style>